import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { RbacService } from '@stg-js-ngx-core/oauth';
import { MmtCommonService } from '../../services/mmt-common.service';


@Injectable({
  providedIn: 'root'
})
export class RecommendationService {

  constructor(private http: HttpClient,
    private commonService: MmtCommonService,) { }

  saveRecomendation(mailBody): Observable<any> {
    const body = {
      userEmail: this.commonService.getEmail(),
      userName: this.commonService.getUserFullName(),
      toEmail: environment.constants.denialEmail,
      ccEmails: '',
      userRecommendation: mailBody
    };
    return this.http.post(environment.urls.emailRecommendation, body);
  }
}
